// removed by extract-text-webpack-plugin
module.exports = {"modal_animation_duration":"200ms","absolute-center":"onfido-sdk-ui-Modal-absolute-center","portal":"onfido-sdk-ui-Modal-portal","modalBody":"onfido-sdk-ui-Modal-modalBody","overlay":"onfido-sdk-ui-Modal-overlay","overlay--after-open":"onfido-sdk-ui-Modal-overlay--after-open","overlay--before-close":"onfido-sdk-ui-Modal-overlay--before-close","inner":"onfido-sdk-ui-Modal-inner","closeButton":"onfido-sdk-ui-Modal-closeButton","closeButtonLabel":"onfido-sdk-ui-Modal-closeButtonLabel","closeButtonFullScreen":"onfido-sdk-ui-Modal-closeButtonFullScreen"};


//////////////////
// WEBPACK FOOTER
// ./components/Modal/style.css
// module id = 377
// module chunks = 1